import SavedExpenses from "../../components/saved-expenses/saved-expenses";

function SavedExpensesRoute() {
  return <SavedExpenses />;
}

export default SavedExpensesRoute;
